export default __webpack_public_path__ + "static/media/chattt.57946962.png";